import { StyledFormInputWrapper } from 'styles/formStyles.css'
import styled from 'styled-components'
import FormikTextField from 'components/TextFieldFormik'
import { RateLimitAccountLevelEnum } from 'types/rateLimit'
import DropdownFormik from 'components/DropdownFormik'

const account_level = [
    {
        label: RateLimitAccountLevelEnum.Starter,
        value: RateLimitAccountLevelEnum.Starter,
    },
    {
        label: RateLimitAccountLevelEnum.Pro,
        value: RateLimitAccountLevelEnum.Pro,
    },
    {
        label: RateLimitAccountLevelEnum.Enterprise,
        value: RateLimitAccountLevelEnum.Enterprise,
    },
]

const RateLimitForm = ({ formik, subnets, subnet_api_services }: any) => {
    return (
        <StyledFormInputWrapper>
            <StyledGridBox>
                <div>
                    <FormikTextField
                        name='per_hour'
                        placeholder={'Requests per hour'}
                        label={'Requests per hour'}
                    />
                </div>
                <div>
                    <FormikTextField
                        name='per_day'
                        placeholder={'Requests per day'}
                        label={'Requests per day'}
                    />
                </div>
            </StyledGridBox>

            <StyledSingleBox>
                <div>
                    <FormikTextField
                        name='per_month'
                        placeholder={'Requests per month'}
                        label={'Requests per month'}
                    />
                </div>
            </StyledSingleBox>

            <div>
                <DropdownFormik
                    label={'Account level'}
                    fieldName={'account_level'}
                    setFieldValue={formik?.setFieldValue}
                    fieldValue={formik.values.account_level}
                    options={account_level}
                    optionSize={'small'}
                    size={'small'}
                    labelGap={4}
                />
            </div>
            <div>
                <DropdownFormik
                    label={'Subnet'}
                    fieldName={'subnet_id'}
                    setFieldValue={formik?.setFieldValue}
                    fieldValue={formik.values.subnet_id}
                    options={subnets}
                    optionSize={'small'}
                    size={'small'}
                    labelGap={4}
                    disabled
                />
            </div>
            <div>
                <DropdownFormik
                    label={'Subnet API services'}
                    fieldName={'subnet_api_service_id'}
                    setFieldValue={formik?.setFieldValue}
                    fieldValue={formik.values.subnet_api_service_id}
                    options={subnet_api_services}
                    optionSize={'small'}
                    size={'small'}
                    labelGap={4}
                    disabled
                />
            </div>
        </StyledFormInputWrapper>
    )
}

export default RateLimitForm

const StyledGridBox = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    align-items: start;
`

const StyledSingleBox = styled.div`
    display: grid;
`
